import { RelatedInventoryRiskItem } from '../../../Api/Projects/projectsApi';
import { DetailViewCard } from '../../Compounds/CardWithTitle';
import { MiniRiskWidget } from '../../Compounds/RiskSummaryWidget';
import { useAttachments } from '../../../store/Attachment';
import { AttachmentTable } from '../../Compounds/AttachmentTable';
import { DetailsComments } from '../../Compounds/DetailsComments';
import { shouldSeeComments } from '../../../store/User';
import { ProjectAssetContacts } from './ProjectAssetContacts';
import { AssetDetailRows, AssetHistoryCard } from './AssetDetailSections';
import { useProjectAssetDetails } from './useProjectAssetDetails';

export interface ProjectAssetDetailsProps {
  // Risk rows from the project detail payload carry riskTier/riskLabel/riskMessage;
  // legacy inventory-store rows don't, so the widget renders only in risk mode.
  asset: RelatedInventoryRiskItem;
}

export function ProjectAssetDetails({ asset }: ProjectAssetDetailsProps) {
  const { fieldList, assetLoading, account } = useProjectAssetDetails(asset);
  useAttachments();

  return (
    <>
      <MiniRiskWidget
        item={asset}
        className="mt-4"
      />
      <DetailViewCard
        enableCollapse
        key="project-asset"
        title="Details"
        collapsed={false}>
        <div className="overflow-auto h-[30vh]">
          <AssetDetailRows
            fields={fieldList}
            loading={assetLoading}
          />
        </div>
      </DetailViewCard>
      {asset.id && (
        <AttachmentTable
          id={asset.id}
          parentType="Asset"
        />
      )}
      <ProjectAssetContacts
        assetId={asset.id}
        projectId={asset.projectId || ''}
        accountId={account?.id || ''}
      />
      {shouldSeeComments() && asset?.id && (
        <DetailsComments
          id={asset.id}
          entityType="Inventory"
          entityAccountId={asset.account_id || ''}
        />
      )}
      {asset.id && (
        <AssetHistoryCard
          notes={asset.notes}
          collapsed={true}
        />
      )}
    </>
  );
}
